// extracted by mini-css-extract-plugin
export default {"subheading-text":"Testimonials_subheading-text__-p9Ay"};